import React, {Component} from 'react';
import {NEW_IMAGE_PATH} from 'Constants';
import { Tooltip,OverlayTrigger } from 'react-bootstrap';

export default class PublishContentListItem extends Component{
  constructor(props){
    super(props);
  }

  render(){
    
    var item=this.props.item;

    var itemID=`tooltip-${item.icon}`;

    return(
      <div>
        <div>
          <img src={`${NEW_IMAGE_PATH}publish/${item.icon}.png`}/>
            {" "}<span>{item.content}{" "}</span>
            {
              (item.details !== '')?
              <OverlayTrigger
                key={item.icon}
                placement='right'
                overlay={
                  <Tooltip id={itemID}>
                    {item.details}
                  </Tooltip>
                }
                >
                <img
                  className="publish-tooltip"
                  src={`${NEW_IMAGE_PATH}publish/question_icon.png`}
                  />
              </OverlayTrigger>:null
            }
        </div>
      </div>
    )
  }
}
